import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, saveConsent } from "../lib/tracking";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener("pv-open-cookie-banner", open);
    return () => window.removeEventListener("pv-open-cookie-banner", open);
  }, []);

  const choose = (marketing) => {
    saveConsent(marketing);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[100]"
          data-testid="cookie-banner"
        >
          <div className="rounded-2xl bg-[#2B1930]/95 backdrop-blur-xl border border-[#C8A6A1]/25 p-6 shadow-2xl">
            <p className="font-display text-lg font-bold text-[#F7F2EA] mb-2">I tuoi dati, la tua scelta</p>
            <p className="text-sm text-[#F7F2EA]/70 leading-relaxed mb-4">
              Utilizziamo cookie tecnici e, con il tuo consenso, cookie di marketing (Meta Pixel) per
              misurare le conversioni e mostrarti annunci personalizzati su Meta, TikTok, YouTube e Google.
              Leggi la{" "}
              <Link to="/cookie-policy" className="underline text-[#C8A6A1] hover:text-[#D83A52]">
                Cookie Policy
              </Link>{" "}
              e la{" "}
              <Link to="/privacy-policy" className="underline text-[#C8A6A1] hover:text-[#D83A52]">
                Privacy Policy
              </Link>
              .
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                data-testid="cookie-accept-all-btn"
                onClick={() => choose(true)}
                className="flex-1 rounded-full bg-[#D83A52] text-white text-sm font-bold py-3 px-5 hover:brightness-110 hover:-translate-y-0.5 active:scale-[0.98] transition-transform shadow-[0_8px_25px_rgba(216,58,82,0.35)]"
              >
                Accetta tutti
              </button>
              <button
                data-testid="cookie-necessary-only-btn"
                onClick={() => choose(false)}
                className="flex-1 rounded-full border border-[#F7F2EA]/30 text-[#F7F2EA] text-sm font-semibold py-3 px-5 hover:bg-[#F7F2EA]/10 transition-colors"
              >
                Solo necessari
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
